import { useContext } from 'react';

import { QConfigGeneratorDetailsContext } from './qconfig-generator-details-provider';

function useQConfigGeneratorDetails() {
  const context = useContext(QConfigGeneratorDetailsContext);

  if (!context) {
    throw new Error(
      'useQConfigGeneratorDetails must be used within a QConfigGeneratorDetailsProvider',
    );
  }

  return context;
}

export { useQConfigGeneratorDetails };
